import { Fragment, useContext, useState } from 'react'

import classNames from 'classnames'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUpDownLeftRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'
import { Trans } from '@lingui/macro'
import { Context as AssociationFolderContext } from 'Root/App/Contexts/AssociationFolderContext'

import styles from '../index.module.css'

library.add(faUpDownLeftRight)

const MoveTo = ({ element }) => {
  const { setFolder } = useContext(AssociationFolderContext)

  function getTypeName() {
    if (element.__typename.includes('Collection')) {
      return 'collection'
    } else if (element.__typename === 'Folder') {
      return 'folder'
    } else {
      return 'content'
    }
  }

  return (
    <Menu.Item as={Fragment}>
      {({ active, ...props }) => (
        <button
          className={classNames(
            active ? styles.active : styles.notActive,
            styles.item
          )}
          onClick={() =>
            setFolder({
              id: element.id,
              visibility: element.visibility,
              parent_folder_id: element.parent_folder_id,
              __typename: getTypeName(),
            })
          }
          {...props}
        >
          <FontAwesomeIcon
            className={styles.icon}
            icon={['fas', 'up-down-left-right']}
          />
          <Trans>Sposta In</Trans>
        </button>
      )}
    </Menu.Item>
  )
}

export default MoveTo
